<template>
  <div id="app">
    <header class="fixed-header">
      <div class="nav-container">
        <NavMenu @showQuote="toggleQuoteBox" />
        <MobileMenu @showQuote="toggleQuoteBox" />
      </div>
    </header>
    <main class="main-content">
      <Quoteform @showQuote="toggleQuoteBox" v-if="showQuote" />
      <div class="overlay" v-if="showQuote" @click="toggleQuoteBox(false)"></div>
      <router-view @showQuote="toggleQuoteBox" />
      <ContactUs />
    </main>
  </div>
</template>

<script>
import NavMenu from "./components/NavMenu";
import MobileMenu from "./components/MobileMenu.vue";
import Quoteform from "./components/Quote.vue";
import ContactUs from "./components/contact-us.vue";
export default {
  name: "App",
  data() {
    return {
      showQuote: false
    };
  },
  components: {
    NavMenu,
    MobileMenu,
    Quoteform,
    ContactUs
  },
  methods: {
    toggleQuoteBox(info) {
      this.showQuote = info;
      if (info) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  },
  mounted() {
    // Intersection Observer for scroll-triggered fade-in animations
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    this.$nextTick(() => {
      document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    });
  }
};
</script>

<style>
:root {
  --color-bg: #0c0a09;
  --color-surface: #171412;
  --color-surface-raised: #1c1917;
  --color-border: #292524;
  --color-text: #fafaf9;
  --color-text-muted: #a8a29e;
  --color-fire: #ea580c;
  --color-fire-light: #f97316;
  --color-amber: #f59e0b;
  --color-amber-light: #fbbf24;
  --font-display: 'Space Grotesk', sans-serif;
  --font-body: 'Inter', sans-serif;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  background-color: var(--color-bg);
  color: var(--color-text);
}

#app {
  font-family: var(--font-body);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-text);
  background-color: var(--color-bg);
  position: relative;
}

/* ── NOISE TEXTURE OVERLAY ── */
#app::before {
  content: '';
  position: fixed;
  inset: 0;
  opacity: 0.03;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
  background-repeat: repeat;
  background-size: 256px 256px;
  pointer-events: none;
  z-index: 9999;
}

a {
  text-decoration: none;
  color: inherit;
}

.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.nav-container {
  height: 72px;
}

.main-content {
  padding-top: 72px;
}

.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  z-index: 9;
}

.section-label {
  font-family: var(--font-display);
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--color-fire);
  margin-bottom: 0.75rem;
}

.section-title {
  font-family: var(--font-display);
  font-size: clamp(1.75rem, 4vw, 2.5rem);
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.02em;
  color: var(--color-text);
}

/* ── SCROLL REVEAL ANIMATIONS ── */
.reveal {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.7s cubic-bezier(0.0, 0.0, 0.2, 1),
              transform 0.7s cubic-bezier(0.0, 0.0, 0.2, 1);
}

.reveal.visible {
  opacity: 1;
  transform: translateY(0);
}

/* Stagger children */
.reveal-stagger .reveal:nth-child(1) { transition-delay: 0ms; }
.reveal-stagger .reveal:nth-child(2) { transition-delay: 60ms; }
.reveal-stagger .reveal:nth-child(3) { transition-delay: 120ms; }
.reveal-stagger .reveal:nth-child(4) { transition-delay: 180ms; }
.reveal-stagger .reveal:nth-child(5) { transition-delay: 240ms; }
.reveal-stagger .reveal:nth-child(6) { transition-delay: 300ms; }

/* Respect reduced motion */
@media (prefers-reduced-motion: reduce) {
  .reveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
}

@media (max-width: 768px) {
  .main-content {
    padding-top: 64px;
  }
}
</style>
